import { observer } from 'mobx-react';
import React, { useCallback } from 'react';
import itemsStore from '../../store/itemsStore';
import { booleanNumberReverse } from 'src/utils/helpers';
import { Checkbox } from 'src/view/components/Controls/Checkbox/Checkbox';

const ItemApplyAvailabilityToAll: React.FC = observer((): JSX.Element | null => {
  const changeApplyAvailabilityToAll = useCallback(() => {
    itemsStore.changeItemHandler({ apply_availability_to_all: booleanNumberReverse(itemsStore.item?.apply_availability_to_all) });
  }, [itemsStore.item?.apply_availability_to_all]);

  if (itemsStore.item?.is_draft) return null;

  return (
    <div className="d-flex flex-column mt-6">
      <Checkbox
        value={Boolean(itemsStore.item?.apply_availability_to_all)}
        name="checkbox_apply_availability_and_stock_for_all_branches"
        label="checkbox_apply_availability_and_stock_for_all_branches"
        onClick={changeApplyAvailabilityToAll}
      />
    </div>
  );
});

export default ItemApplyAvailabilityToAll;
